export enum LicensePlateVariant {
  NLYellow = 'NLYellow',
  NLYellowSquare = 'NLYellowSquare',
  NlYellowMoped = 'NlYellowMoped',
  NLBlueMoped = 'NLBlueMoped',
  NLBlue = 'NLBlue',
  NLBlueSquare = 'NLBlueSquare',
  NLGreen = 'NLGreen',
  NLGreenSquare = 'NLGreenSquare',
  NLWhite = 'NLWhite',
  NLWhiteSquare = 'NLWhiteSquare',
  BEWhiteRed = 'BEWhiteRed'
}
